import { useEffect, useState } from "react";
import { createApiClient } from "../api/client";
import { formatTime } from "../lib/time";
import { App } from "./App";
import { tillCredentials } from "./session";
import { SUPPORT_ENDED_EVENT, supportWindow, type SupportWindow } from "./support";

/**
 * The till in a support window of Tafo (prototype renderSupBar): the yellow bar on top ("🛟 Support-modus ·
 * je werkt als … sinds … · elke wijziging komt in het logboek") with Stoppen, and the till itself below.
 * Staff still sign in with their own code; everything is logged in the name of the support till.
 */
export function SupportApp() {
  const [session, setSession] = useState<SupportWindow | null>(() => supportWindow.read());
  const [stopping, setStopping] = useState(false);
  const [api] = useState(() => createApiClient(tillCredentials));

  useEffect(() => {
    const ended = () => {
      setSession(null);
    };
    window.addEventListener(SUPPORT_ENDED_EVENT, ended);
    return () => {
      window.removeEventListener(SUPPORT_ENDED_EVENT, ended);
    };
  }, []);

  if (session === null) {
    return (
      <div className="support-ended">
        <img src="/tafo-logo.png" alt="Tafo" width={95} height={24} />
        <h1>Support-sessie gestopt</h1>
        <p>Deze kassa is niet meer gekoppeld. Je kan dit venster sluiten.</p>
      </div>
    );
  }

  const stop = () => {
    setStopping(true);
    api
      .request("POST", "/device/support/stop")
      .catch(() => undefined)
      .finally(() => {
        supportWindow.end();
        window.close();
      });
  };

  return (
    <>
      <div className="support-bar" role="status">
        <span>
          🛟 <b>Support-modus</b> · je werkt als <b>{session.shop}</b> sinds {formatTime(session.since)} · elke
          wijziging komt in het logboek
        </span>
        <button type="button" className="btn" disabled={stopping} onClick={stop}>
          Stoppen
        </button>
      </div>
      <App />
    </>
  );
}
